import {Button, Form, Input, Modal, notification} from "antd";
import {useEffect, useState} from "react";
import {FormProps} from "antd/lib/form/Form";
import {FieldData} from "../../../models/filter-table/filter-table";
import {UrlService} from "../../../services/url";
import {EditOwnersFormComponentProps, UpdateOwnerFormFields} from "../../../models/owner/owner";
import ownerService from "../../../services/owner-service";

export const EditOwnerModal = ({ recallData, owner, close, openCloseState, propertyId }: EditOwnersFormComponentProps)  => {

    console.log("ownerEditModal triggered", owner);

    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const [formData, setFormData] = useState<FieldData[]>([
        {name: ["id"], value: owner.id},
        {name: ["name"], value: owner.name},
        {name: ["lastName"], value: owner.lastName},
        {name: ["personalCode"], value: owner.personalCode},
        {name: ["companyName"], value: owner.companyName},
        {name: ["companyRegisterNumber"], value: owner.companyRegisterNumber},
        {name: ["contactPersonName"], value: owner.contactPersonName},
        {name: ["contactPersonLastName"], value: owner.contactPersonLastName},
        {name: ["phone"], value: owner.phone},
        {name: ["email"], value: owner.email},
        {name: ["address"], value: owner.address},
    ]);

    useEffect(() => {
        setFormData([
            {name: ["id"], value: owner.id},
            {name: ["name"], value: owner.name},
            {name: ["lastName"], value: owner.lastName},
            {name: ["personalCode"], value: owner.personalCode},
            {name: ["companyName"], value: owner.companyName},
            {name: ["companyRegisterNumber"], value: owner.companyRegisterNumber},
            {name: ["contactPersonName"], value: owner.contactPersonName},
            {name: ["contactPersonLastName"], value: owner.contactPersonLastName},
            {name: ["phone"], value: owner.phone},
            {name: ["email"], value: owner.email},
            {name: ["address"], value: owner.address},
        ])
    }, [owner])

    const handleCancel = () => {
        close();
    }

    const onFinish: FormProps['onFinish'] = async (values) => {
        console.log(form.getFieldsValue());
        close();
        let status = await ownerService.update(form.getFieldsValue() as UpdateOwnerFormFields);
        if (!status) {
            api.error({
                message: 'Error',
                description:
                'Error while adding new connection',
                showProgress: true,
                pauseOnHover: true,
                duration: 7,
            });
        } else {
            recallData()
        }
        // recallData();
    };

    const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    };

    return (
        <>
            {contextHolder}
            <Modal
            open={openCloseState}
            title="Изменение данных владельца"
            onCancel={close}
            footer={[]}
            >
                <Form
                    form={form}
                    fields={formData}
                    name="filter-table-filter"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    style={{ width: "100%" }}
                >
                    <Form.Item name="id" hidden={true}>
                        <Input placeholder="" type={"text"} />
                    </Form.Item>
                    <Form.Item name="name" label="Имя">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="lastName" label="Фамилия">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="personalCode" label="Личный код">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="companyName" label="Название фирмы">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="companyRegisterNumber" label="Регистрационный код фирмы">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="contactPersonName" label="Имя контактного лица">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="contactPersonLastName" label="Фамилия контактного лица">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="phone" label="Телефон">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="email" label="Имейл">
                        <Input placeholder="" type={"email"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item name="address" label="Адрес">
                        <Input placeholder="" type={"text"} autoComplete="off" autoCapitalize="none" autoCorrect="off"/>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{marginRight: "10px"}}>Изменить</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}